import React from 'react';
import RulesConfirmModal from '../rulesEngine/RulesConfirmModal';

const ClearBoxCatalogConfirmModal = ({visible, onConfirm, onCancel}) => {
  return (
    <RulesConfirmModal
      visible={visible}
      title="Reset Box Catalog"
      message="Reset the box catalog? Every box will be removed, and BoxChamp won't be able to pack orders until you re-upload a CSV."
      confirmText="Reset"
      cancelText="Cancel"
      showUndoneWarning
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default ClearBoxCatalogConfirmModal;
